import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail, Phone, MapPin } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { CONTACT, SOCIAL } from "../data/site";

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer className="relative z-10 border-t border-[var(--line)] mt-24" data-testid="site-footer">
      <div className="container-x py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="display text-3xl mb-3 font-serif italic">
            Lotus Sutra
          </div>
          <p className="text-sm text-[var(--ink-soft)] max-w-md">
            {t.footer.tagline}
          </p>
          <div className="flex items-center gap-3 mt-5">
            <a
              href={SOCIAL.instagram}
              target="_blank" rel="noopener noreferrer"
              className="w-10 h-10 rounded-full border border-[var(--line)] flex items-center justify-center hover:bg-[var(--terracotta)] hover:text-[var(--cream-soft)] hover:border-[var(--terracotta)] transition-all"
              data-testid="footer-instagram"
              aria-label="Instagram"
            ><Instagram size={16} /></a>
            <a
              href={SOCIAL.facebook}
              target="_blank" rel="noopener noreferrer"
              className="w-10 h-10 rounded-full border border-[var(--line)] flex items-center justify-center hover:bg-[var(--terracotta)] hover:text-[var(--cream-soft)] hover:border-[var(--terracotta)] transition-all"
              data-testid="footer-facebook"
              aria-label="Facebook"
            ><Facebook size={16} /></a>
          </div>
        </div>

        <div>
          <div className="kicker mb-4">{t.contact.label}</div>
          <ul className="space-y-2 text-sm">
            <li className="flex items-center gap-2"><Phone size={14} /><a href={`tel:${CONTACT.phoneLink}`}>{CONTACT.phone}</a></li>
            <li className="flex items-center gap-2"><Mail size={14} /><a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a></li>
            <li className="flex items-start gap-2"><MapPin size={14} className="mt-1" /><span>{CONTACT.street}<br />{CONTACT.zip} {CONTACT.city}, {CONTACT.country}</span></li>
          </ul>
        </div>

        <div>
          <div className="kicker mb-4">Legal</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/impressum" data-testid="footer-impressum-link" className="hover:text-[var(--terracotta)]">{t.footer.impressum}</Link></li>
            <li><Link to="/datenschutz" data-testid="footer-datenschutz-link" className="hover:text-[var(--terracotta)]">{t.footer.datenschutz}</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[var(--line)]">
        <div className="container-x py-5 text-xs text-[var(--ink-soft)] flex flex-col md:flex-row items-center justify-between gap-2">
          <span>© {year} {CONTACT.name} · Lotus Sutra. {t.footer.rights}</span>
          <span className="tracking-[0.25em] uppercase">{t.footer.tagline}</span>
        </div>
      </div>
    </footer>
  );
}
